module.exports = __webpack_public_path__ + "media/images/emblems/Bolligen-coat_of_arms-d14d290bc03c49ea39ab9bfac3674883.svg";